import { render, staticRenderFns } from "./admin.view.vue?vue&type=template&id=f6568f98&"
import script from "./admin.view.ts?vue&type=script&lang=ts&"
export * from "./admin.view.ts?vue&type=script&lang=ts&"
import style0 from "./admin.view.less?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports